import dayjs from 'dayjs';
import { IComponent } from 'src/interfaces';

export const getEarliestComponentExpiryDate = (
  components: IComponent[],
): string | null => {
  return components.reduce<string | null>((earliestEndDate, component) => {
    const endDate = component.end_date;
    if (
      !endDate ||
      (earliestEndDate !== null &&
        !dayjs(endDate).isBefore(dayjs(earliestEndDate)))
    ) {
      return earliestEndDate;
    }

    return endDate as string;
  }, null);
};
